export const baseURL = "https://admin.hikulive.com/";
export const key = "p+lYJzn1dUaBDQytJk5DVehBAvhzJTSGmSJvcLh6kLo";

